<template>
  <div>
     <b-form @submit.prevent="save">
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                :label="$t('systematic_intimidation.general_orientation')"
                label-for="general_orientation">
              <validation-provider
                #default="{ errors }"
                name="general_orientation">
                <complex-editor :editor_data.sync="general_orientation"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                :label="$t('receiving_emails')"
                label-for="emailsInput">
              <validation-provider
                #default="{ errors }"
                name="emailsInput">
                <!--Tags input-->
                <emails-input
                  ref="emailsInput"
                  :emailsInput="emailsInitialTag"
                  @emailsChanged="emailsChanged"
                  :sendButton="false"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="flex justify-end mb-4">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right mr-1"
            type="submit">
            Salvar
          </b-button>
          <b-button
              variant="outline-secondary"
              class="float-right"
              @click="goBack">
              <feather-icon
                icon="CornerUpLeftIcon"
                class="mr-50"/>
              <span class="align-middle">{{$t('back')}}</span>
          </b-button>
        </div>
     </b-form>
      <!-- -->
      <b-card-code
        :key="id"
        title="URL Formulário de Intimidação Sistemática"
        codeVisible="true"
        showCopy="true"
        codeEmbed="true"
        :shortUrl="shortUrl">
        <b-card-text>
          Use esta URL para que a instituição/empresa possa abrir o formulário de intimidação sistemática.
        </b-card-text>
        <template #code>
          {{ formUrl }}
        </template>
      </b-card-code>

      <b-card-code
        :key="id"
        title="Protocolo - Página de Consulta Pública"
        codeVisible="true"
        showCopy="true"
        codeEmbed="true">
        <b-card-text>
          Use esta URL para realizar consulta da situação e tratamento do formulário de Intimidação Sistemática.
        </b-card-text>
        <template #code>
          {{ protocolQueryUrl }}
        </template>
      </b-card-code>
      <div class="flex justify-end">
        <b-button
            variant="outline-secondary"
            class="float-right"
            @click="goBack">
            <feather-icon
              icon="CornerUpLeftIcon"
              class="mr-50"/>
            <span class="align-middle">{{$t('back')}}</span>
          </b-button>
      </div>
  </div>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code'
import ComplexEditor from '@/components/ComplexEditor.vue'
import EmailsInput from '@/components/EmailsInput.vue'

import SystematicIntimidationService from '@/services/api/intimidation/SystematicIntimidationService'

export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardCode,
    BCardText,
    BFormInput,
    // validations
    ValidationProvider,
    ValidationObserver,
    ComplexEditor,
    EmailsInput,
  },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    legalEntity: null,
    general_orientation: '',
    emails: [],
    emailsInitialTag: [],
    service: null,
  }),
  watch: {
    //Não retirar, verificar a lógica da consulta da legalEntity
    '$store.state.legalEntity.legalEntity'(legalEntity) {
      this.legalEntity = legalEntity
      if(this.legalEntity){
        this.getData(this.legalEntity.id)
      }
    }
  },
  computed: {
    formUrl() {
      if (this.legalEntity && this.legalEntity.systematic_intimidation_form_url) {
        return `${this.legalEntity.systematic_intimidation_form_url}`
      }
      return ''
    },
    protocolQueryUrl() {
      if (this.legalEntity && this.legalEntity.systematic_intimidation_protocol_query_url) {
        return `${this.legalEntity.systematic_intimidation_protocol_query_url}`
      }
      return 'unknown'
    },
    shortUrl(){
      if (this.legalEntity && this.legalEntity.systematic_intimidation_short_url) {
        return `${this.legalEntity.systematic_intimidation_short_url}`
      }
      return null
    },
  },
  methods: {
    goBack() {
      this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
      this.$router.push({name: 'people-legal-entities'})
    },
    getData(id) {
      this.$vs.loading()
      this.service.read(id).then(
        data => {
          this.emailsInitialTag = _.get(data, 'data.emails');
          this.general_orientation = _.get(data, 'description');
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = {
        id: this.legalEntityId,
        legal_entity_id: this.legalEntityId,
        description: this.general_orientation ? this.general_orientation : '',
        emails: this.emails
      }

      this.service.createOrUpdate(params).then(
        data => {
          this.notifySuccess(this.$vs)
        },
        error => {
          this.showErrors(this.$validator, error)
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    emailsChanged(emails) {
      this.emails = emails
    }
  },
  beforeMount() {
    this.service = SystematicIntimidationService.build(this.$vs)
  },
  mounted() {
    const legalEntity = this.$store.getters['legalEntity/legalEntity']
    if (legalEntity) {
      this.legalEntity = legalEntity
    }
    if (this.legalEntityId) {
      this.getData(this.legalEntityId)
    }
  },
  beforeDestroy() {
    this.destroyChilds(this)
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
